module.exports = __webpack_public_path__ + "static/media/T9-01.629788a9.svg";